export const multiSelectMaxCount = (value: any, max: number) => {
  if (value?.length > max) {
    value.pop();
  }
};
